import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import MKBox from "components/MKBox";
//import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";
import React from "react";
import bgImage from "assets/images/instructions.png";
import vidRegistration from "assets/videos/Kuntalive_Rekisteroityminen.mp4";
import vidActivation from "assets/videos/Kuntalive_aktivoiminen.mp4";
import vidComment from "assets/videos/Strategia_kommentit_720p.mp4";
import vidMap from "assets/videos/Strategia_kartta_720p.mp4";
import vidBudget from "assets/videos/Strategia_budjetointi_720p.mp4";
import vidSwot from "assets/videos/Strategia_swot_720p.mp4";
import vidFocus from "assets/videos/Strategia_painopisteet_720p.mp4";
import { useTranslation } from "react-i18next";
import ReactPlayer from "react-player";
//import { Card, CardContent, Typography, Button, TextField } from "@mui/material";
/* eslint-disable react/prop-types */
const Instructions = () => {
  const [t] = useTranslation("common");
  return (
    <>
      <MKBox
        minHeight="23vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "2500px 500px",
          backgroundPosition: "top",
          display: "grid",
          placeItems: "left",
        }}
      />
      <MKBox pt={6} px={1} mt={6}>
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="left" mx="auto">
            <MKTypography
              variant="h1"
              color="black"
              mt={-6}
              mb={1}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              <h2>{t("instructions.header")}</h2>
            </MKTypography>
            <MKTypography
              variant="body1"
              color="black"
              textAlign="left"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              <div>
                {t("instructions.text")}
                <br />
                <br />
                <h3>{t("instructions.registrationheader")}</h3>
                {t("instructions.registration")}
                <ReactPlayer controls>
                  <source src={vidRegistration} type="video/mp4" />
                </ReactPlayer>
                <br />
                <br />
                <h3>{t("instructions.activationheader")}</h3>
                {t("instructions.activation")}
                <ReactPlayer controls>
                  <source src={vidActivation} type="video/mp4" />
                </ReactPlayer>
                <br />
                <br />
                <h3>{t("instructions.accountheader")}</h3>
                {t("instructions.account")}
                <br />
                <br />
                <h3>{t("instructions.strategytools")}</h3>
                {t("instructions.comment")}
                <ReactPlayer controls>
                  <source src={vidComment} type="video/mp4" />
                </ReactPlayer>
                <br />
                <br />
                <h3>{t("instructions.swotheader")}</h3>
                {t("instructions.swot")}
                <ReactPlayer controls>
                  <source src={vidSwot} type="video/mp4" />
                </ReactPlayer>
                <br />
                <br />
                <h3>{t("instructions.mapheader")}</h3>
                {t("instructions.map")}
                <ReactPlayer controls>
                  <source src={vidMap} type="video/mp4" />
                </ReactPlayer>
                <br />
                <br />
                <h3>{t("instructions.focusareasheader")}</h3>
                {t("instructions.focusareas")}
                <ReactPlayer controls>
                  <source src={vidFocus} type="video/mp4" />
                </ReactPlayer>
                <br />
                <br />
                <h3>{t("instructions.budgetheader")}</h3>
                {t("instructions.budget")}
                <ReactPlayer controls>
                  <source src={vidBudget} type="video/mp4" />
                </ReactPlayer>
                <br />
                <br />
                <h3>{t("instructions.menuheader")}</h3>
                {t("instructions.menu")}
                <br />
                <br />
                <h3>{t("instructions.responsiveviewheader")}</h3>
                {t("instructions.responsiveview")}
                <br />
                <br />
                <h3>{t("instructions.municipalitiesheader")}</h3>
                {t("instructions.municipalities")}
                <br />
                <br />
                <h3>{t("instructions.institutionsheader")}</h3>
                {t("instructions.institutions")}
                <br />
                <br />
                <h3>{t("instructions.meetingsheader")}</h3>
                {t("instructions.meetings")}
                <br />
                <br />
                <h3>{t("instructions.sectionsheader")}</h3>
                {t("instructions.sections")}
                <br />
                <br />
                <h3>{t("instructions.proposalsheader")}</h3>
                {t("instructions.proposals")}
                <br />
                <br />
                <h3>{t("instructions.commentsheader")}</h3>
                {t("instructions.comments")}
                <br />
                <br />
                <h3>{t("instructions.linksheader")}</h3>
                {t("instructions.links")}
                <br />
                <br />
                <h3>{t("instructions.contactheader")}</h3>
                {t("instructions.contact")}
                <br />
                <br />
              </div>
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
    </>
  );
};

export default Instructions;
